// La matrice des droits, lue dans le même fichier que le serveur (panel/permisos.json).
// Le serveur APPLIQUE, l'interface MASQUE : un bouton caché n'est jamais la seule défense.
import permisos from "../../../../panel/permisos.json";

export type Rol = "owner" | "admin" | "editor" | "viewer" | "operator";
export type Accion = keyof typeof permisos.acciones;

export function puede(rol: Rol | undefined, accion: Accion): boolean {
  return !!rol && (permisos.acciones[accion] as string[]).includes(rol);
}

export const ROLES_CLIENTE = permisos.roles_cliente as Exclude<Rol, "operator">[];
